module.exports = __webpack_public_path__ + "img/logo-title.f9b76a9a.png";